export default __webpack_public_path__ + "static/img_welfare_2-061453dce1a21f04a385cdfcf506a557.jpg";